import React from 'react';
import toolActions from '../../redux/futures/tools/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import baseHelper from '../../helpers/BaseHelper';
import Input from '../../components/Input';

import * as types from '../../redux/futures/tools/types';
import userActions from '../../redux/futures/user/actions';
import * as userTypes from '../../redux/futures/user/types';
import ConfirmModal from '../../components/ConfirmModal';



class CreateDemoAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {

                emailOld: "",

                emailNew: "",
                user_name: "",
            },
            userInfo: {
                email: "",
                password: "",
            },
            users: [],
            typing: false,
            typingTimeout: 0,
            loading: false,
            loadingCreate: false,
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary",
            mode: ''
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
        // this.defaultState = _.cloneDeep(this.state.user);
    }


    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {


            if (nextProps.user.action == userTypes.USER_LIST) {
                this.setState({
                    loading: false,
                    classApply: this.state.classNormal
                });
                if (nextProps.user.status) {
                    this.setState({
                        users: nextProps.user.users
                    });

                } else {
                    window.LadiUI.toastr('error', '', nextProps.user.message);
                }
            }
            if (nextProps.tool.action == types.CREATE_DEMO_ACCOUNT) {
                console.log('nextProps.tool.status', nextProps.tool);

                window.LadiUI.closeModalById('confirm-create-demo-account');
                if (nextProps.tool.status) {
                    window.LadiUI.toastr('success', '', nextProps.tool.message);
                    this.setState({
                        userInfo: nextProps.tool.userInfo,
                        loadingCreate: false,
                        classApply: this.state.classNormal
                    });
                } else {
                    this.setState({
                        loadingCreate: false,
                        classApply: this.state.classNormal
                    });
                    window.LadiUI.toastr('error', '', nextProps.tool.message);
                }
            }
        }
    }
    submit = (selectedID) => {

        this.selectedID = selectedID;

        window.LadiUI.showModalById('confirm-create-demo-account');

    }
    acceptCreateDemoAccount = () => {

        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            // console.log(ref);
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }
        const { user } = this.state;
        const jsonData = {
            "from_email": user.emailOld,
            "user_name": user.user_name,
        }
        this.props.createDemoAccount(jsonData);

        this.state.loadingCreate = true;
        this.state.classApply = this.state.classLoading;

    }


    onChangeInput = (event) => {

        this.setState({
            user: {
                ...this.state.user,
                [event.target.name]: event.target.value
            }
        });
    }


    resetForm = (event) => {
        if (!event.target.hasAttribute("data-dismiss")) {
            return;
        }

        this.setState({
            user: baseHelper.resetState(this.state.user),
        });
        window.LadiUI.closeModal(this.ref.current);

        // window.LadiUI.forEach(window.LadiUI.querySelector("#modal-store .ladiui input"), function (e) {
        //     e.classList.remove('error');
        // });
    }

    find = () => {
        const { user } = this.state;
        const jsonData = {
            "limit": 20,
            "offset": 0,
            "email": user.emailOld,
            "phone": "",
            "fullname": "",
            "id": "",
            "status": true,
            "is_partner": "ALL"
        }
        this.props.findDemoAccount(jsonData);
        this.setState({
            loading: true,
            classApply: this.state.classLoading,
        });
    }

    render() {
        const { user, users, userInfo } = this.state;
        console.log(users);

        const title = 'Tạo tài khoản demo.';

        return (
            <div ref={this.ref} id="modal-create-demo-account" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-create-demo-account"
                onClick={this.resetForm}>
                <div className="ladiui-modal-content" >
                    <div className="ladiui-modal-header"><button type="button" className="ladiui-close-modal" data-dismiss="modal-create-demo-account"><i className="ladi-icon icon-e-remove" data-dismiss="modal-create-demo-account" /></button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body">

                        {userInfo.email == "" &&
                            <div>
                                <h3 style={{ marginBottom: "20px" }}>Các email gốc sử dụng để tạo tài khoản demo. Chỉ chọn email gốc trong danh sách sau:</h3>
                                <ul>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>anhnth123mirai@gmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>testladipage8@yopmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>tientran13101999@gmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>ladiflowzns@gmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>demokhoahoc.ladipage@gmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>demospa.ladipage@gmail.com</p></label></li>
                                    <li><label className="ladiui-label"><p style={{ fontWeight: "500" }}>demobatdongsan.ladipage@gmail.com</p></label></li>
                                </ul>
                            </div>
                        }
                        {userInfo.email != "" && (
                            <div>
                                <h3 style={{ marginBottom: "20px" }}>Thông tin tài khoản demo đã tạo:</h3>
                                <div className="ladiui-row">
                                    <label className="ladiui-label">Email: <p style={{ fontWeight: "500" }}>{userInfo.email}</p></label>
                                    <label className="ladiui-label">Mật khẩu: <p style={{ fontWeight: "500" }}>{userInfo.password}</p></label>
                                </div>
                            </div>
                        )}
                        <form>
                            <div className="ladiui-tab-content">
                                <div className="ladiui-row">

                                    <div >
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Email gốc</label>
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="emailOld"
                                                validationName="Email"
                                                placeholder="Email"
                                                value={user.emailOld}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true, email: true }}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="ladiui-row">

                                    <div >
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Người request</label>
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="user_name"
                                                validationName="Tên Sale Admin request"
                                                placeholder="Sale Admin Name"
                                                value={user.user_name}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true }}
                                            />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </form>
                        <div className="ladiui-row">
                            <table className="ladiui table">
                                <thead>
                                    <tr>
                                        <th className="text-left">Tên</th>
                                        <th className="text-left">Email</th>
                                        <th className="text-left">Package</th>
                                        <th className="text-left">Số điện thoại</th>
                                        <th className="text-left">Thời gian tạo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        _.map(users, user => {
                                            return <tr key={user._id}>
                                                <td>{user.fullname.trim()}{user.is_partner && <span title="Partner ship"> <i className="ladi-icon icon-d-check" style={{ cursor: "pointer", color: "#0C61F2", marginLeft: "10px", fontSize: "17px" }} /> </span>}</td>
                                                <td>{user.email}</td>
                                                <td>{user.pkg_name || '--'}</td>
                                                <td>{user.phone}</td>
                                                <td>{baseHelper.formatStrToDate(user.created_at)}</td>
                                            </tr>
                                        }
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-create-demo-account">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-create-demo-account" />Đóng
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.find}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Kiểm tra email gốc
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loadingCreate}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Tạo tài khoản demo
                        </button>

                    </div>
                </div>
                <ConfirmModal
                    id="confirm-create-demo-account"
                    title="Xác nhận tạo tài khoản demo"
                    content="Bạn có chắc chắn muốn tạo tài khoản demo?"
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={this.acceptCreateDemoAccount}
                />
            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        findDemoAccount: (data) => dispatch(userActions.list(data)),
        createDemoAccount: (data) => dispatch(toolActions.createDemoAccount(data))
    }
}

const mapStateToProps = (state) => ({ tool: { ...state.tool }, user: { ...state.user } });

export default connect(mapStateToProps, mapDispatchToProps)(CreateDemoAccount);